import React from "react";
import { Redirect, Route } from "react-router-dom";
import { getSessionStorageItem, ADVISOR_OBJECT_KEY } from "../../sessionStorage";
import { getPermission } from "./CheckAccess";
import accessPermission from "../Helpers/Constants/AccessPermission";
import { UnauthorizedPath } from "../Common/Products/ProductsRoute";

export default function ProtectedRoute(props) {

    const { component: Component, path, appGoal, premiumGoal, user, exact, permissionKey, setActiveLink, navLinks } = props;

    var advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
    var role = advisorObj && advisorObj.role;

    const permission = getPermission(role, permissionKey);
    return(
        <Route path={path} exact={exact} render={(props) => permission !== accessPermission.notAuthorizedPermission ? <Component {...props} permission={permission} appGoal={appGoal} premiumGoal={premiumGoal} user={user} setActiveLink={setActiveLink} navLinks={navLinks} /> : <Redirect to={UnauthorizedPath} /> } />
    )
};



// WEBPACK FOOTER //
// ./src/components/Helpers/ProtectedRoute.js